import React from 'react'
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/chaturmas.css"; // chatrumas css used here 

export const Chaturmas = () => {
  return (
    <>  
        <PageHeader title="द्वादशी व्रत" path="/about-goshala" name=" goshala" />
        <div className="chaturmas-section">
                          <div className="chaturmas-container">
                          {/* container  */}
                          <div className="chaturmas-sub-section">
                            {/* sub-section */}
                            <div className="chaturmas-img-container">
                              <img
                                className="chaturmas-image"
                                src={sansthanImg.s_img09}
                                alt=""
                              />
                            </div>
                           
                            <div className="chaturmas-info-container">
                              <h3>द्वादशी व्रत  </h3>
                              <p>
                                &nbsp;&nbsp;&nbsp;&nbsp;चातुर्मास द्वादशी व्रत - या व्रतांतर्गत चातुर्मासातील सर्वात द्वादशांच्या दिवशी संस्थांच्या अनेक शिष्यकाळांच्या माध्यमातून द्वादशी अन्नदानाची पंगत प्रतिवर्षी नियमितपणे होत असते. या प्रत्येक द्वादशीस 250 ते 500 भाविक दर्शन व द्वादशी प्रसादासाठी सद्गुरू चरणी उपस्थित असतात.
                              </p>
                             
                                 

                            </div>
                          </div>
                        
                          {/* second one  */}

                          {/* <div className="chaturmas-sub-section">
                            <hr  className='responsive-divider'/>
                            <div className="youtube-video-container">
                            <iframe width="660" height="415" src="https://www.youtube.com/embed/_kVzI6Btv3w?si=e0gB93RYMNmThmal" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                           </div>
                          </div> */}

                
                          <div className="chaturmas-sub-section"></div>
                        </div>
                      </div>
         
    </>
);

}
